import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navigation from './Navigation';
import Footer from './Footer';
import apiClient from '../utils/apiClient';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      setLoading(true);
      const data = await apiClient.login(email, password);
      login(data.token);
      navigate('/dashboard');
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'Failed to log in');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter your email address');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      await apiClient.requestReset(email);
      setSuccess('Password reset instructions have been sent to your email');
      setError('');
    } catch (err) {
      console.error('Reset request error:', err);
      setError(err.message || 'Failed to request password reset');
      setSuccess('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <Navigation />
      <div className="container">
        <div className="main-content">
          <div className="form-container">
            <h2 className="form-title">Log In</h2>
            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-input"
                />
              </div>
              <div className="auth-links">
                <button type="submit" className="button button-primary">
                  Log In
                </button>
                <button
                  onClick={handleForgotPassword}
                  className="button button-link"
                >
                  Forgot Password?
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;